import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../common/ConfirmationModal/ConfirmationModal';
import { useLanguage } from '../../utils/language';

const AttachmentRemovePrompt = ({ toggleModal, onConfirm }) => {
  const { t } = useTranslation();
  const { langCode } = useLanguage();

  return (
    <ConfirmationModal
      testId="attachment-remove-prompt"
      lang={langCode}
      loading={false}
      onClose={toggleModal}
      onConfirm={onConfirm}
      title={t('Remove Attachment')}
      buttonTextConfirm={t('Remove')}
      buttonTextCancel={t('Cancel')}
    >
      <span>{t('Are you sure you want to remove the attachment?')}</span>
    </ConfirmationModal>
  );
};

AttachmentRemovePrompt.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default AttachmentRemovePrompt;
